import request from '@/utils/request'
/**
 * 权限公用接口
 */

// 获取第一层路由映射表
export function getFirstRouterMap() {
  return request({
    url: '/author/firstMap',
    method: 'get'
  })
}

// 获取第二层路由映射表
export function getSecondRouterMap() {
  return request({
    url: '/author/secondMap',
    method: 'get'
  })
}

// 获取用户路由组列表
export function getGroupRouterList(data: { groupId: string | number }) {
  return request({
    url: '/author/routerList',
    method: 'get',
    params: data
  })
}

// 获取角色组名映射
export function getGroupMapList() {
  return request({
    url: '/author/groupMap',
    method: 'get'
  })
}
